<template>
  <div class="page">
    <Header :title="title" :show-back="true" />
    <CourseNormalList ref="normal-list" v-if="courseType === 'normal'" :category-id="categoryId" />
    <CourseVideoList ref="video-list" v-if="courseType === 'video'" :category-id="categoryId" />
    <CourseOfflineList ref="offline-list" v-if="courseType === 'offline'" :category-code="categoryInfo.categoryCode" />
    <CourseOnlineList ref="online-list" v-if="courseType === 'online'" :category-code="categoryInfo.categoryCode" />
  </div>
</template>

<script>
import Header from '@/components/header'
import courseApi from '@/api/course'
import CourseNormalList from './components/course-normal-list'
import CourseVideoList from './components/course-video-list'
import CourseOfflineList from './components/course-offline-list'
import CourseOnlineList from './components/course-online-list'
export default {
  name: 'CourselList',
  components: {
    Header,
    CourseNormalList,
    CourseVideoList,
    CourseOfflineList,
    CourseOnlineList
  },
  data () {
    return {
      categoryId: '',
      categoryInfo: {}
    }
  },
  computed: {
    title () {
      return this.categoryInfo.categoryName ? this.categoryInfo.categoryName : '博世课堂'
    },
    courseType () {
      return this.categoryInfo.categoryCode === '1031' ? 'offline'
        : this.categoryInfo.categoryCode === '1032' ? 'online'
          : this.categoryInfo.categoryCode && this.categoryInfo.categoryCode.indexOf('xtv') > -1 ? 'video' : 'normal'
    }
  },
  created () {
    this.categoryId = this.$route.params.categoryId
    this.queryCategoryInfo()
  },
  methods: {
    queryCategoryInfo () {
      courseApi.queryCourseCategoryInfo(this.categoryId).then(response => {
        if (response.data.resultCode === '0') {
          this.categoryInfo = response.data.resultData.courseCategoryInfo
          this.$nextTick(() => {
            if (this.courseType === 'normal') {
              this.$refs['normal-list'].load()
            }
            if (this.courseType === 'video') {
              this.$refs['video-list'].load()
            }
            if (this.courseType === 'offline') {
              this.$refs['offline-list'].load()
            }
            if (this.courseType === 'online') {
              this.$refs['online-list'].load()
            }
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
